import CrudRepository from './CrudRepository'
export default class SignInRepository extends CrudRepository {
  constructor () {
    super('api/users/signin')
  }
}
